import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Files,
  ZoomIn,
  Scale,
  Timer,
  CircleDollarSign,
  CalendarDays,
  Percent,
  FileEdit,
  SlidersHorizontal,
  Clock,
  Ticket,
  Calculator,
  Search,
  Wallet,
  DownloadCloudIcon,
  BotMessageSquare,
  School
} from "lucide-react";

const tools = [
  {
    id: "convert-files",
    label: "شارژ کیف پول",
    href: "/wallet",
    icon: Wallet,
    tone: "purple",
  },
  {
    id: "search-registries",
    label: "پشتیبان گیری",
    href: "/backup",
    icon: DownloadCloudIcon,
    tone: "gray",
    badge: "جدید",
  },
  {
    id: "delay-penalty",
    label: "مشاوره حقوقی",
    href: "/messages/2/09900000000",
    icon: BotMessageSquare,
    tone: "purple",
  },
  {
    id: "Scale",
    label: "محاسبه‌ هزینه دادرسی",
    href: "/calculator/filingFee",
    icon: Scale,
    tone: "green",
    badge: "جدید",
  },
  {
    id: "meeting-reminder",
    label: "یادآوری جلسات",
    href: "/events",
    icon: Clock,
    tone: "purple",
  },
  {
    id: "tax-stamp",
    label: "محاسبه تمبر مالیاتی",
    href: "/calculator/lawyerFee",
    icon: Ticket,
    tone: "green",
    badge: "جدید",
  },
  {
    id: "lawyer-fee",
    label: "محاسبه حق‌الوکاله",
    href: "/calculator/lawyerFee",
    icon: Calculator,
    tone: "purple",
    badge: "جدید",
  },
  {
    id: "Court",
    label: "آدرس دادگاه ها",
    href: "https://adliran.ir/Home/GetUnit",
    icon: School,
    tone: "gray",
    target: true,
    badge: "جدید",
  },
];

const toneClasses = {
  purple: "bg-primary/10 text-primary",
  gray: "bg-gray-100 text-gray-500",
  green: "bg-emerald-50 text-emerald-700",
};

function ToolCard({ label, href, icon: Icon, tone,target, badge }) {
  return (
    <Link
      to={href}
      target={target && "_blank"}
      className="group relative flex flex-col items-center gap-3 overflow-visible rounded-2xl p-3 pt-4 text-center transition hover:bg-gray-50"
    >
      {badge && (
        <span className="absolute -top-1 right-2 z-2 whitespace-nowrap rounded-full bg-primary px-2.5 py-0.5 text-[11px] font-medium leading-5 text-white shadow-sm">
          {badge}
        </span>
      )}
      <span
        className={`flex h-16 w-16 items-center justify-center rounded-2xl transition group-hover:brightness-95 ${toneClasses[tone]}`}
      >
        <Icon className="h-6 w-6" strokeWidth={1.75} />
      </span>
      <span className="text-sm font-medium text-gray-800">{label}</span>
    </Link>
  );
}

export default function QuickAccessPanel() {
  const [query, setQuery] = useState("");

  const filteredTools = useMemo(() => {
    const q = query.trim();
    if (!q) return tools;
    return tools.filter((tool) => tool.label.includes(q));
  }, [query]);

  return (
    <div className="rounded-3xl bg-white p-8 shadow-sm ring-1 ring-gray-100 mb-8">
      {/* هدر */}
      <div className="mb-8 flex flex-wrap items-center justify-between gap-4">
        <h2 className="flex items-center gap-2 text-lg font-bold text-gray-900">
          دسترسی سریع
        </h2>

        <div className="flex flex-1 flex-wrap items-center justify-end gap-3">
          {/* جستجو: در موبایل مخفی، از sm به بالا نمایش داده می‌شود */}
          <label className="hidden w-full max-w-xs items-center gap-2 rounded-2xl bg-gray-100 px-4 py-3 text-sm text-gray-500 sm:flex sm:w-64">
            <Search className="h-4 w-4 shrink-0" strokeWidth={1.75} />
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="جستجوی منابع"
              className="w-full bg-transparent text-sm text-gray-700 placeholder:text-gray-400 focus:outline-none"
            />
          </label>
        </div>
      </div>

      {/* شبکه ابزارها */}
      {filteredTools.length > 0 ? (
        <div className="grid grid-cols-3 gap-6 md:grid-cols-5 lg:grid-cols-7">
          {filteredTools.map((tool) => (
            <ToolCard key={tool.id} {...tool} />
          ))}
        </div>
      ) : (
        <p className="py-6 text-center text-sm text-gray-400">موردی پیدا نشد</p>
      )}
    </div>
  );
}
